import { CartItem } from '../cart/cartItem'; 

export class Cart {
cartItems: Array<CartItem>; 

constructor(){
    this.cartItems = new Array<CartItem>();
}



}




// WEBPACK FOOTER //
// ./src/app/cart/cart.ts